import React from 'react';
import { Button, Modal, Typography } from 'antd';
import {
  SafetyCertificateFilled,
  LockOutlined,
  MobileOutlined,
  ThunderboltOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import NeverBox from './NeverBox';

// Modal « double authentification »: the former TwoFactorSuggestion.jsx, same design.
// The texts of the database row replace the default ones when they are filled in
// (titre, sous_titre, points [{ titre, texte }], note, cta, plus_tard).
const { Title, Text } = Typography;

// LaCaisse colors (--primary-dark / --primary-darker in the back office styles).
const BRAND = '#d4243a';
const BRAND_DARK = '#9a3743';

const ICONS = [<LockOutlined />, <MobileOutlined />, <ThunderboltOutlined />];

const DEFAULT_BENEFITS = [
  {
    titre: 'Protection renforcée',
    texte: 'Même avec votre mot de passe, personne ne peut accéder à votre compte sans votre téléphone.',
  },
  {
    titre: 'Simple au quotidien',
    texte: 'Un code à 6 chiffres depuis Google Authenticator, Microsoft Authenticator ou Authy.',
  },
  {
    titre: 'Activation rapide',
    texte: "Scannez un QR code, saisissez un code : c'est terminé.",
  },
];

export default function DoubleAuthentification({ popup, text, open, loading, onDone, onLater, onClose, never, setNever, zIndex }) {
  const benefits = text.points && text.points.length ? text.points : DEFAULT_BENEFITS;

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered width={460} maskClosable={false} zIndex={zIndex}>
      {/* Header band (negative margins cancel the antd modal padding) */}
      <div
        style={{
          margin: '-20px -24px 0',
          padding: '22px 24px 18px',
          borderRadius: '14px 14px 0 0',
          background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            margin: '0 auto 10px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.35)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SafetyCertificateFilled style={{ fontSize: 28, color: '#fff' }} />
        </div>
        <Title level={4} style={{ color: '#fff', margin: 0 }}>
          {text.titre || 'Sécurisez votre compte'}
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.85)' }}>{text.sous_titre || 'Activez la double authentification'}</Text>
      </div>

      {/* Benefits */}
      <div style={{ padding: '16px 4px 0' }}>
        {benefits.map((b, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <div
              style={{
                flex: '0 0 36px',
                height: 36,
                borderRadius: 10,
                background: '#fff5f5',
                color: BRAND,
                fontSize: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {ICONS[i % ICONS.length]}
            </div>
            <div>
              <Text strong style={{ display: 'block' }}>
                {b.titre}
              </Text>
              <Text type="secondary" style={{ fontSize: 13 }}>
                {b.texte}
              </Text>
            </div>
          </div>
        ))}

        <div style={{ textAlign: 'center', margin: '0 0 12px' }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            <ClockCircleOutlined /> {text.note || "Moins d'une minute"}
          </Text>
        </div>

        <Button
          type="primary"
          size="large"
          block
          loading={loading}
          onClick={onDone}
          style={{ background: BRAND, borderColor: BRAND, height: 44, fontWeight: 600 }}
        >
          {text.cta || 'Activer maintenant'}
        </Button>
        <Button type="text" block onClick={onLater} style={{ marginTop: 4, color: '#8c8c8c' }}>
          {text.plus_tard || 'Plus tard'}
        </Button>
        <NeverBox show={popup.peut_masquer} checked={never} onChange={setNever} />
      </div>
    </Modal>
  );
}
